<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-12">
        <header><h2 class="no-divider">Student Counselling & Mentoring Service</h2></header>

        <div id="page-main">
          <section>
            <p>
              The university counselling service helps students to cope up with the problems that affect their studies
              as well as personal life. The students have the opportunity to discuss their various socio-economic and
              mental problems or any other matters with the counsellors.Academic staff members who have been appointed
              as student counsellors offer their assistance, advice and guidance to students. Students can contact any
              student counsellor using the provided contact information.
            </p>
          </section>
          <section id="members">

            <section id="our-staff">
              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a href="http://www.tec.ruh.ac.lk/pages/ProfSaman.php" target="_blank">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/096b74097473a4f7b863bcee3c278677.jpg"
                        alt="Prof. E.P.S. Chandana"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a href="http://www.tec.ruh.ac.lk/pages/ProfSaman.php" target="_blank">Prof. E.P.S.
                            Chandana</a>
                        </header>
                        <span class="desitination-staff">Deputy Vice Chancellor</span>
                        <div>
                          <p>University of Ruhuna</p>
                        </div>
                        <p>
                          <span>dvcepsc@admin.ruh.ac.lk</span>
                          <span><br>+94 775909665</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              <hr>
              <h4 class="no-divider">Counselling staff</h4>
              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/amaraweera">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/14cf22de897f27f79164c4bf0da6bf3e.jpg"
                        alt="Dr. P. H. Amaraweera"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/amaraweera">Dr. P. H. Amaraweera</a>
                        </header>
                        <span class="desitination-staff">Senior Student Counsellor </span>
                        <div>
                          <p>Department of Geography, Faculty of Humanities and Social Sciences</p>
                        </div>
                        <p>
                          <span>palitha.amaraweera@gmail.com</span>
                          <span><br>+94 711367656</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/amaraweera">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/14cf22de897f27f79164c4bf0da6bf3e.jpg"
                        alt="Dr. P. H. Amaraweera"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/amaraweera">Dr. P. H. Amaraweera</a>
                        </header>
                        <span class="desitination-staff">Deputy Senior Student Counsellor</span>
                        <div>
                          <p>Department of Geography</p>
                        </div>
                        <p>
                          <span>palitha.amaraweera@gmail.com</span>
                          <span><br>+94 711367656</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->
              <hr>
              <h4 class="no-divider">Student Counsellors</h4>
              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/ariyawimala">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/da565ac4315a34efd66b9c0c864ace57.jpg"
                        alt="Rev. T. Ariyawimala"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/ariyawimala">Rev. T. Ariyawimala</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Pali & Buddhist Studies</p>
                        </div>
                        <p>
                          <span>taldena14@gmail.com</span>
                          <span><br>+94 718036899</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/ariyawansa">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/39119dbff2643dbb7efdcbe7547aeef6.jpg"
                        alt="Rev. Dr. Morakandegoda Ariyawansa"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/ariyawansa">Rev. Dr. Morakandegoda Ariyawansa</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Sinhala</p>
                        </div>
                        <p>
                          <span>ariyawansamora@gmail.com</span>
                          <span><br>+94 712914870</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

              </div>

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/dayalatha">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/dfa381f2707dbc8558ff4953e84c0bed.jpg"
                        alt="Dr. W.K.V. Dayalatha"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/dayalatha">Dr. W.K.V. Dayalatha</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Geography</p>
                        </div>
                        <p>
                          <span>wkvdayalatha@yahoo.com</span>
                          <span><br>+94 0714469507</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/Pathmasiri">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/Pathmasiri%20EHGC.jpg.jpg"
                        alt="Dr. E.H.G.C. Pathmasiri"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/Pathmasiri">Dr. E.H.G.C. Pathmasiri</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Geography</p>
                        </div>
                        <p>
                          <span>ehgcpathmasiri@gmail.com</span>
                          <span><br>+94 724014987</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/ariyarathne">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/5a61efdfc2d5bd87cde81023654d4007.jpg"
                        alt="Dr. N.S. Ariyarathna"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/ariyarathne">Dr. N.S. Ariyarathna</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Departmenisanariyarathne@yahoo.comnt of Public Policy</p>
                        </div>
                        <p>
                          <span>nisanariyarathne@yahoo.com</span>
                          <span><br>+94 771296874</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/sulakkanagamage">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/bf4fa290d3107f556441acd9ca1211ea.jpg"
                        alt="Ms. I.G. Sulakkana Kumari"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/sulakkanagamage">Ms. I.G. Sulakkana Kumari</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Economics</p>
                        </div>
                        <p>
                          <span>gamagesulakkana@gmail.com</span>
                          <span><br>+94 717029776</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/karunarathna">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/996084cbcc6cf1901bc63807d346f49f.jpg"
                        alt="Ms. L.S. Karunarathna"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/karunarathna">Ms. L.S. Karunarathna</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Sinhala</p>
                        </div>
                        <p>
                          <span>lokeshsk28@gmail.com</span>
                          <span><br>+94 774440098</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/wijepala">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/62adfb2786271915adae34c7642eb3d2.jpg"
                        alt="Mr. N.G.U.S. Wijepala"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/wijepala">Mr. N.G.U.S. Wijepala</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer</span>
                        <div>
                          <p>Department of Sociology</p>
                        </div>
                        <p>
                          <span>ngusanjeewa@gmail.com</span>
                          <span><br>+94 752024639</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/fernando_p">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/image%20(1).jpg.jpg"
                        alt="Ms. L.S. Karunarathna"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/fernando_p">Ms. P.W.S.  Fernando</a>
                        </header>
                        <span class="desitination-staff">Lecturer (Prob)</span>
                        <div>
                          <p>Department of Geography</p>
                        </div>
                        <p>
                          <span>pwsurandi@geo.ruh.ac.lk</span>
                          <span><br>+94 071685433</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/Mayuri">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/44c16423aed3dafe45dab40b85e37b44.jpg"
                        alt="Ms. D.R.W.M.N. Kularathna"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/Mayuri">Ms. D.R.W.M.N. Kularathna</a>
                        </header>
                        <span class="desitination-staff">Lecturer</span>
                        <div>
                          <p>Department of Public Policy</p>
                        </div>
                        <p>
                          <span>mayurindii@gmail.com</span>
                          <span><br>+94 0703253484</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/kandewatta">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/9b3ab23ac996b372dc016a9a3f66e2be.jpg"
                        alt="Mr. K. Kandewatta"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/kandewatta">Mr. K. Kandewatta</a>
                        </header>
                        <span class="desitination-staff">Lecturer (Prob)</span>
                        <div>
                          <p>Department of Economics</p>
                        </div>
                        <p>
                          <span>kamalkandewatta@econ.ruh.ac.lk</span>
                          <span><br>+94 710154520</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/ishara">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/80ca6b5a0395f71bc6d284d218000603.jpg"
                        alt="Ms. W.A.K. Ishara Madushani"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/ishara">Ms. W.A.K. Ishara Madushani</a>
                        </header>
                        <span class="desitination-staff">Lecturer (Prob)</span>
                        <div>
                          <p>Department of Sociology</p>
                        </div>
                        <p>
                          <span>isharawanniarachchi@soci.ruh.ac.lk</span>
                          <span><br>+94 711079183</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/dilhani">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/aed6036cdbb00b17ed0669161549b935.jpg"
                        alt="Ms. E.V. D. Dilhani"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/dilhani">Ms. E.V. D. Dilhani</a>
                        </header>
                        <span class="desitination-staff">Lecturer (Prob)</span>
                        <div>
                          <p>Department of Economics</p>
                        </div>
                        <p>
                          <span>danushka@hss.ruh.ac.lk</span>
                          <span><br>+94 717046089</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/Anuradha%20Gamage">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/3a68c73d18c44617766a1726e6c8e8d4.jpg"
                        alt="Ms. Anuradha Gamage"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/Anuradha%20Gamage">Ms. Anuradha Gamage</a>
                        </header>
                        <span class="desitination-staff">Lecturer (Prob)</span>
                        <div>
                          <p>Department of Economics</p>
                        </div>
                        <p>
                          <span>anuradhagamage5@gmail.com</span>
                          <span><br>+94 711079183</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->

              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/sandamali">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/a3d5cd9f3f44d5418aef2005dc542377.jpg"
                        alt="Ms. I.R.N. Sandamali Peris"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/sandamali">Ms. I.R.N. Sandamali Peris</a>
                        </header>
                        <span class="desitination-staff">Lecturer</span>
                        <div>
                          <p>Department of Sinhala</p>
                        </div>
                        <p>
                          <span>nadeekasp.@sinh.ruh.ac.lk</span>
                          <span><br>+94 719434547</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/sameera">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/48e703a866ee873d2187f776ece73f2f.jpg"
                        alt="Ms. M.A.G.J. Sameera"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/sameera">Ms. M.A.G.J. Sameera</a>
                        </header>
                        <span class="desitination-staff">Lecturer</span>
                        <div>
                          <p>Department of Sinhala</p>
                        </div>
                        <p>
                          <span>jayani.sameera7@gmail.com</span>
                          <span><br>+94 717665533</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->
.
              <div class="row">
                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/sandamali">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/a3d5cd9f3f44d5418aef2005dc542377.jpg"
                        alt="Ms. I.R.N. Sandamali Peris"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/sandamali">Ms. I.R.N. Sandamali Peris</a>
                        </header>
                        <span class="desitination-staff">Lecturer</span>
                        <div>
                          <p>Department of Sinhala</p>
                        </div>
                        <p>
                          <span>nadeekasp.@sinh.ruh.ac.lk</span>
                          <span><br>+94 719434547</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->

                <div class="col-md-6 col-sm-6">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/sameera">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/03aad049e028752ac5b44a8114503ed3.jpg"
                        alt="Ms. H.M.T.M.H. Molagoda"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/molagoda">Ms. H.M.T.M.H. Molagoda</a>
                        </header>
                        <span class="desitination-staff">Lecturer</span>
                        <div>
                          <p>Department of English  Language Teaching </p>
                        </div>
                        <p>
                          <span>tilasham@eltu.ruh.ac.lk</span>
                          <span><br>+94 717665533</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->
              <hr>
              <h4 class="no-divider">Chief Mentor</h4>
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/sarath">
                      <figure class="author-picture"><img
                        src="https://docs.fohss.lk/storage/0dbd61057a19f1d42453a7ecc60d299c/0dbd61057a19f1d42453a7ecc60d299c/ab48cd48348aa5978cded448d6804b39.jpg"
                        alt="Ms. M.A.G.J. Sameera"></figure>
                    </a>
                    <article class="paragraph-wrapper">
                      <div class="inner">
                        <header>
                          <a routerLink="/staff/sarath">Ms. M.A.G.J. Sameera</a>
                        </header>
                        <span class="desitination-staff">Senior Lecturer / Head of the Department</span>
                        <div>
                          <p>Department of Economics</p>
                        </div>
                        <p>
                          <span>katuku@econ.ruh.ac.lk </span>
                          <span><br>+94 0716981997</span>
                        </p>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div>
            </section><!-- /#our-speakers -->
          </section>
          <hr>

        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
